// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!./assets/bootstrap-grid.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../node_modules/@nackle/paper/dist/index.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  max-height: 100%;
  overflow-y: scroll;
}
.content {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
}
.search-icon {
  align-items: center;
  padding-top: 5px;
}
.bp3-input.bp3-fill {
  width: 350px;
}
.anticon {
  padding-top: inherit;
}
.nkl-layout .nkl-layout-has-sider {
  min-height: 80rem;
}
.nkl-input-group-addon {
  border: 1px solid #d9d9d9;
}
.nkl-input-group-addon .nkl-input-search-button {
  border: 1px solid #d9d9d9;
}
.nkl-modal-wrap {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: inherit;
}
.rom-card-header {
  border-bottom: 1px solid lightgrey;
  padding-left: 10px;
}
.content-configuration {
  border-bottom: 1px solid lightgrey;
  padding-left: 10px;
}
.dialog-footer-delete {
  margin-left: 65%;
}
.nkl-modal .nkl-modal-content {
  border-radius: 6px;
}
.arcade-form .nkl-drawer-header-title {
  padding-top: 0px;
}
.page-content {
  padding: 0 1.5rem 1.5rem;
}
.section-header {
  font-weight: 400;
}
.main-section {
  background-color: #fff;
  min-height: 100vh;
  padding: 1.5rem;
}
.search-section {
  width: 50%;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
